import { Component, OnInit, AfterViewInit, ViewChild, TemplateRef, ElementRef, Inject, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { BsModalService, BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { Parcel } from 'src/app/_models/parcel';

import {FormsModule} from "@angular/forms";
import { GoogleAnalyticsService } from 'src/app/_services/GoogleAnalytics.service';
import { News } from 'src/app/_models/news';
import {VideoGridElement} from "../../_shared/videos-grid/video-grid-element.model";


@Component({
    selector: 'app-prop19',
    templateUrl: './prop19.component.html',
    styleUrls: ['./prop19.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Prop19Component implements OnInit {
  id: number;
  ain: string;
  parentSelector = true;
  parentExclusion = false;
  baseYearSelector = true;
  toggle: boolean;
  newsRecent: News[];

  calc1Values: calcValues;
  calc2Values: calc2Values;

  videos: VideoGridElement[] = [
    {
      url: 'https://www.youtube.com/embed/x6mTmxhRM-s',
      title: 'Nicole White-Gamble Speaking at the Homeownership Legacy Workshop with Macedonia Baptist Church',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/fb4g6JcGWuc?list=PL99qj8Q3_1psopvHemZMeUntqzEw7-m5a',
      title: 'Presentation 2: Proposition 19 & Death of a Property Owner',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/DOvX-7MIyx4',
      title: 'Podcast: 790 KABC Mottek On Money with Assessor Jeff Prang',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/-EgVNcykiXY',
      title: 'PROP. 19 – WILL I BE ELIGIBLE FOR A BASE YEAR VALUE TRANSFER?',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/PQrvFBOjjWc',
      title: 'PROP. 19 – TAX BASE FROM AN ORIGINAL PROPERTY TO REPLACEMENT PROPERTY ANYWHERE IN THE STATE.',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/L9hIGHhMXYA',
      title: 'PROP. 19 – HOMEOWNERS’ EXEMPTION TO QUALIFY FOR THE PARENT-CHILD AND GRANDPARENT-GRANDCHILD EXCLUSIONS?',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/5aJ7iOz_zLs',
      title: 'Prop. 19 Town Hall (12/08/21)',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/OXc8TSyZhaA',
      title: 'What is Prop. 19? (1/22/21)',
      powerpoint: 'https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1627751261/Webinars%20and%20Presentations/LA_County_Assessor_Prop._19_Webinar_1_22_21.pdf'
    }
  ];

  constructor(private actRoute: ActivatedRoute, private router: Router, private apiService: ApiService, @Inject(DOCUMENT) document, private google: GoogleAnalyticsService) {
    this.id = this.actRoute.snapshot.params.id;
    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd){
        console.log(event.url)
        if(event.url == '/real-estate-toolkit/proposition-19')
          this.toggle = true;
       }
    }
 )
  }

  submitAin(form?: string) {
    if(this.ain) {
      this.apiService.getParcel(this.ain.replace(/\D/g,'')).subscribe(data => {
        console.log(data);
        this
      .google
      .eventEmitter("Prop 19 Calculator", data.Parcel.SitusCity, data.Parcel.AIN);
        if(form == 'base')
          this.initializeBaseYear(data.Parcel);
        else
          this.initialize(data.Parcel);
      })
    }
  }

  scrollBottom(el: string) {
    console.log(el)

    setTimeout(() => {
      const element = document.getElementById(el);
      element.scrollIntoView();
     }, 500);


  }

  getAddress(event: Parcel, form?: string) {

    this.apiService.getParcel(event.AIN).subscribe(data => {
      console.log(data);
      if(form == 'base')
          this.initializeBaseYear(data.Parcel);
      else
        this.initialize(data.Parcel);
    })
  }

  initialize(item: Parcel) {
    this.calc1Values = {
      fairMarketValue: 0,
      taxableValue: Number(item.RollPreparation_ImpValue) + Number(item.RollPreparation_LandValue),
      millionDollarExclusion: 1000000
    }
    this.scrollBottom('MarketValueParent');
  }
  initializeBaseYear(item: Parcel) {
    this.calc2Values = {
      fairMarketValue: 0,
      fairMarketValueReplacement: 0,
      taxableValue: Number(item.RollPreparation_ImpValue) + Number(item.RollPreparation_LandValue),
      millionDollarExclusion: 1000000
    }
    this.scrollBottom('MarketValueBaseYear');
    console.log('BaseYear')
  }

  checkValue() {
    return this.calc1Values.fairMarketValue <= (this.calc1Values.millionDollarExclusion + this.calc1Values.taxableValue)
  }
  checkParentValue() {
    return this.calc2Values.fairMarketValueReplacement > this.calc2Values.fairMarketValue
  }



  ngOnInit() {
    this.apiService.getNews().subscribe(data => {
      console.log(data)

      this.newsRecent = data.filter(it => {
        if(it.pageId==14)
          return it
      })


      //Press Releases
    })
  }

}

interface calcValues {
  fairMarketValue: number,
  taxableValue: number,
  millionDollarExclusion: number,
}

interface calc2Values {
  fairMarketValue: number,
  fairMarketValueReplacement: number,
  taxableValue: number,
  millionDollarExclusion: number,
}



